import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static values = { show: Boolean }

    async connect() {
        // Lazy-load only the Modal module
        const { default: Modal } = await import("bootstrap/js/dist/modal");

        // Create (or get) the instance for this element
        this.modal = Modal.getOrCreateInstance(this.element, {
            backdrop: "static",
            keyboard: false
        });

        if (this.showValue) this.open();

        // Optional: allow other code to ask this modal to open via event
        this._openHandler = (e) => {
            // if you render multiple country modals, gate by id here
            this.open();
        };
        document.addEventListener("country:open", this._openHandler);
    }

    disconnect() {
        document.removeEventListener("country:open", this._openHandler);
        this.modal?.dispose?.();
    }

    open()  { this.modal?.show(); }
    close() { this.modal?.hide(); }
}